
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    svgName: {
      type: String,
      required: true,
    },
    className: String,
  },
  setup() {
    return {};
  },
});
